import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import * as MySound from '../MySound';


export class LH_DecantBuildArray extends Component {
    static displayName = LH_DecantBuildArray.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            loading: false,
            alertMessage: "",
            selectedContainerRef: "",
            displayValidationSection: false,
            scannedSSCC: "",
            decantLocation: "",
            confirmLocation: ""
        }
    }

    componentDidMount() {
        if (this.props.location && this.props.location.state) {
            this.setState({ selectedContainerRef: this.props.location.state.selectedContainerRef });
            const selectedContainerRef = this.props.location.state.selectedContainerRef;
            if (selectedContainerRef && selectedContainerRef !== "") {
                this.decantArrayCheck(selectedContainerRef);
                this.refs.ssccInput.focus();
            }

        }
    }
    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }

    decantArrayCheck(selectedContainerRef) {
        this.state.loading = true;

        fetch(`api/LinenhouseXdoc/GetDecantArrayCheckResult?containerRef=${selectedContainerRef}`)
            .then(async response => {

                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {

                        if (apiResponse.success) {

                            //TODO : Check with Bruce what to do if this successful
                            return;
                        }
                        else {
                            //TODO: Check with Bruce about the wording of this message
                            this.setState({ alertMessage: "DecantArrayCheck Failed!! :  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "DecantArrayCheck Failed!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    resetSSCCInput(errorMessage) {
        MySound.play(MySound.Sound.stop);
        this.setState({ scannedSSCC: "", alertMessage: errorMessage });
        this.refs.ssccInput.focus();
    }
    validateSSCC() {
        this.setState({ alertMessage: "" });
        if (!this.state.scannedSSCC || this.state.scannedSSCC === "") {
            this.resetSSCCInput("Please scan SSCC");
            return;
        }
        this.state.loading = true;

        fetch(`api/LinenhouseXdoc/ValidateSSCC?sscc=${this.state.scannedSSCC}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            if (data && data.length > 0) {

                                fetch(`api/LinenhouseXdoc/DecantGetLocationBySSCC?containerRef=${this.state.selectedContainerRef}&sscc=${this.state.scannedSSCC}`)
                                    .then(async response => {

                                        this.state.loading = false;
                                        // check for error response
                                        if (!response.ok) {
                                            const errorText = await response.text();
                                            this.setState({ alertMessage: errorText });
                                        }
                                        else {
                                            const isJson = response.headers.get('content-type')?.includes('application/json');
                                            const apiResponse = isJson ? await response.json() : null;

                                            if (apiResponse) {
                                                const data = apiResponse.data;
                                                if (apiResponse.success) {
                                                    if (data && data.length > 0) {

                                                        //map decantLocation
                                                        this.setState({ decantLocation: data[0].putawayloc, displayValidationSection: true });
                                                    }
                                                    else {
                                                        MySound.play(MySound.Sound.next);
                                                        this.goto('../LinenhouseXdoc/LH_DecantAddLocation');
                                                    }

                                                }
                                                else {
                                                    //TODO: Check with Bruce about the wording of this message
                                                    this.setState({ alertMessage: "Failed to validate SSCC!!  " + apiResponse.errorMessage });
                                                }
                                            }
                                            else {
                                                this.setState({ alertMessage: "Failed to validate SSCC!!!!" });
                                            }
                                        }

                                    })
                                    .catch(error => {
                                        this.setState({ alertMessage: error });
                                    });
                            }
                            else {
                                  //TODO: Check with Bruce about the wording of this message
                                this.resetSSCCInput("No Data/Invalid SSCC");
                            }

                        }
                        else {
                            //TODO: Check with Bruce about the wording of this message
                            MySound.play(MySound.Sound.stop);
                            this.setState({ alertMessage: "Failed to validate SSCC!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        MySound.play(MySound.Sound.stop);
                        this.setState({ alertMessage: "Failed to validate SSCC!!!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });


    }
    validateLocation() {
        this.setState({ alertMessage: "" });
        

        if (!this.state.decantLocation || this.state.decantLocation === "") {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Decant location not loaded" });
            this.refs.ssccInput.focus();
            return;
        }

        if (!this.state.confirmLocation || this.state.confirmLocation === "") {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Please confirm the location" });
            this.refs.confirmlocInput.focus();
            return;
        }

        var barCodeFormat = this.state.confirmLocation.split("-");
        if (!barCodeFormat || barCodeFormat.length !== 4) {
            MySound.play(MySound.Sound.stop);
            this.setState({ loading: false, arrayLocation: "", alertMessage: "Invalid Location!! Location should be of this format : Stage-01-01-09" });
            this.refs.arrayLocationInput.focus();
            return;
        }

        //TODO: Check with Bruce if prefixing is needed
        //special requirement to prefix barcode segment with 0 if barcode segment length is 1 (1A-1-1-1 will be prefixed like 1A-01-01-01)
        //this.state.confirmLocation = barCodeFormat[0] + "-" + this.prefixBarcodeSegmentWithZero(barCodeFormat[1]) + "-" + this.prefixBarcodeSegmentWithZero(barCodeFormat[2]) + "-" + this.prefixBarcodeSegmentWithZero(barCodeFormat[3]);


        if (this.state.confirmLocation.trim().toUpperCase() !== this.state.decantLocation.trim().toUpperCase()) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Wrong location" });
            this.refs.confirmlocInput.focus();
            return;
        }
        else {
            MySound.play(MySound.Sound.next);
            this.setState({
                alertMessage: "",
                displayValidationSection: false,
                decantLocation: "",
                confirmLocation: "",
                scannedSSCC:""
            });
            this.refs.ssccInput.focus();
        }
    }
    prefixBarcodeSegmentWithZero(barCodeSegment) {
        if (barCodeSegment.length == 1) {
            barCodeSegment = "0" + barCodeSegment;
        }
        return barCodeSegment;
    }
    render() {

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        const handleSSCCInputKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.validateSSCC();
            }
        };
        const handleConfirmLocInputKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.validateLocation();
            }
        };

        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h4>Decant Build Array</h4></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('../LinenhouseXdoc/LH_DecantPallet'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3" >
                        <Col xs={9}><h5><label>Container: {this.state.selectedContainerRef}</label></h5></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}><label className="font-weight-bold" >Scan carton SSCC:</label></Col>
                        <Col xs={9}><input ref="ssccInput" className="form-control" placeholder="SSCC" value={this.state.scannedSSCC} 
                            onChange={(e) => {
                                this.setState({ scannedSSCC: e.target.value });
                            }} onKeyPress={handleSSCCInputKeyPress} readOnly={this.state.displayValidationSection} >
                        </input></Col>
                    </Row>
                    <Row className="mb-3" style={{ display: this.state.displayValidationSection === true ? 'block' : 'none' }}>
                        <Col xs={3}><label className="font-weight-bold">Go to location :</label></Col>
                        <Col xs={9}><label>{this.state.decantLocation}</label></Col>
                    </Row>
                    <Row className="mb-3" style={{ display: this.state.displayValidationSection === true ? 'block' : 'none' }}>
                        <Col xs={12}>
                            <input ref="confirmlocInput" className="form-control" placeholder="Confirm Location" value={this.state.confirmLocation}
                                onChange={(e) => {
                                    this.setState({ confirmLocation: e.target.value });
                                }} onKeyPress={handleConfirmLocInputKeyPress} readOnly={this.state.loading} >
                            </input>


                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }


}
